// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_S5l","cls2":"PodcastLibraryCarouselAd-cls2_ZwN PodcastLibraryCarouselAd-cls1_S5l"};